/*
 * @Author: LZH
 * @Date: 2025-01-08 14:59:46
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-01-05 16:45:19
 * @Description: 
 */
// const baseconfig = {
//   xinextendUrlapi: 'https://apidev.xin-ptt.com:9001/xinextend',
//   apiAudioUrl: "https://apidev.xin-ptt.com:9001/xinAudio", //测试录音文件平台
//   gpsUrlapi: "https://apidev.xin-ptt.com:9001/xingps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://apidev.xin-ptt.com:9001/sos", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi: "https://apidev.xin-ptt.com:9001/enclosure",                               //电子围栏
//   selfUrlapi: "http://apidev.xin-ptt.com/xinToCApi",
//   getDownPath: "https://apidev.xin-ptt.com:20008",
//   newAgedUrl: "https://dev.broadptt.cn/devweb/dispatching/v1/#/Login",  //老版本路径
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl: { "Content-Type": "application/x-www-form-urlencoded" },
//   socketPz: '49.73.61.229:10001',
//   poc: 'xin'
// };

const baseconfig = {        //正式
    xinextendUrlapi:'https://dmp.xin-ptt.com/extend',
    apiAudioUrl: 'https://audio.xin-ptt.com',//录音文件平台
    gpsUrlapi: 'https://dmp.xin-ptt.com/gps',//定位地址
    mmsUrlapi: 'https://dmp.xin-ptt.com/mms',//广播
    videoUrlapi: 'https://dmp.xin-ptt.com/video',//视频
    sosUrlapi: 'https://dmp.xin-ptt.com/sos',//sos
    regionUrlapi: "https://dmp.xin-ptt.com/region", //区域群组
    enclosureUrlapi:"https://dmp.xin-ptt.com/enclosure",                               //电子围栏
    selfUrlapi: "https://dmp.xin-ptt.com/xintoc",
    getDownPath:"https://dmp.xin-ptt.com:20008",
    newAgedUrl: "https://d.xin-ptt.com/v1/#/Login",  //老版本路径
    ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
    tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
    socketPz: 'disp1.xin-ptt.com:10002',
    poc: 'xin'
}

// const baseconfig = {       //三友   
//     xinextendUrlapi:'https://172.24.3.1:1888/extend',
//     apiAudioUrl: 'https://172.24.3.1:1888/auido',//录音文件平台
//     gpsUrlapi: 'https://172.24.3.1:1888/gps',//定位地址
//     mmsUrlapi: 'https://172.24.3.1:1888/slmedia',//广播
//     videoUrlapi: 'https://172.24.3.1:1888/video',//视频
//     sosUrlapi: 'https://172.24.3.1:1888/sos',//sos
//     regionUrlapi: "https://172.24.3.1:1888/region", //区域群组
//     enclosureUrlapi:"https://172.24.3.1:1888/enclosure",                               //电子围栏
//     getDownPath:"https://172.24.3.1:20008",
//     newAgedUrl: "https://d.xin-ptt.com/v1/#/Login",  //老版本路径
//     ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
//     tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
//     socketPz: '172.24.3.1:10002',
//     poc: 'sanyou'   
// }

export default baseconfig;
